import React from 'react'
import {Modal} from "react-bootstrap"


function ModalPolityka(props) {
    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="lg"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Polityka prywatności</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <p>Polityka Prywatności i wykorzystywania plików cookies w serwisie
          orlencharge.pl (dalej jako "Serwis")</p>
          <p>Administratorem oraz właścicielem serwisu www.orlencharge.pl jest ORLEN S.A. z
          siedzibą w Płocku, ul. Chemików 7, 09-411 Płock, wpisaną do Rejestru
          Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
          Rejonowy dla Łodzi-Śródmieścia w Łodzi XX Wydział Gospodarczy Krajowego
          Rejestru Sądowego pod numerem KRS 0000028860, NIP 774-00-01-454, kapitał
          zakładowy/kapitał wpłacony: 1 451 177 561,25 zł, adres
          elektroniczny: media@orlen.pl (dalej jako: „ORLEN”).</p>
          <p>W Serwisie możesz znaleźć kompleksowe informacje na temat infrastruktury
          ładowania pojazdów elektrycznych, oferowanej przez Grupę ORLEN. Strona
          umożliwia zapoznanie się z lokalizacjami stacji ładowania, rodzajami dostępnych
          ładowarek oraz usługami wspierającymi elektromobilność. Znajdziesz tu również
          informacje o aktualnych promocjach realizowanych w ramach ORLEN CHARGE.</p>
          <p>Niniejsza polityka prywatności zawiera informacje dotyczące przetwarzania danych
          osobowych jakie możesz nam udostępnić podczas korzystania z serwisu oraz
          wykorzystywania plików cookies w naszym serwisie. Naszym celem jest ochrona
          Twoich danych osobowych w Internecie. Dokładamy wszelkich starań aby chronić
          Twoją prywatność w trakcie korzystania z Serwisu. Stosujemy się do uznanych
          międzynarodowych standardów w zakresie bezpieczeństwa, a nasz system
          zarządzania bezpieczeństwem informacji podlega niezależnej certyfikacji i jest
          zgodny z wymogami normy ISO/IEC 27001. Wdrożyliśmy ramowe polityki,
          procedury i szkolenia obejmujące ochronę danych, ich poufność i bezpieczeństwo i
          regularnie dokonujemy kontroli wprowadzonych środków pod kątem ich
          adekwatności dla zabezpieczenia posiadanych danych.</p>

          <h4>Pliki cookies</h4>
          <p><strong>W jakich celach wykorzystywane są pliki cookies?</strong></p>
          <p>Aby strona działała poprawnie, czasami konieczne jest umieszczenie na
          Twoim urządzeniu niewielkich plików danych, zwanych cookies.
          Informacje nt. stosowanych rodzajów plików cookie udostępniamy Tobie w
          formie baneru (okna), który możesz wyświetlić w dowolnym momencie za
          pośrednictwem <a href="javascript: Cookiebot.renew()" class="cookieRenew">tego linku</a>.</p>
          <p>W przypadku niektórych rodzajów plików cookie wymagana jest Twoja
          zgoda, którą możesz zmienić lub odwołać w dowolnym momencie,
          ustawiając swoje preferencje w banerze (oknie), dostępnym za
          pomocą <a href="javascript: Cookiebot.renew()" class="cookieRenew">tego linku</a>.</p>
          <p>Jeśli wyrazisz zgodę na używanie wszystkich rodzajów plików cookie,
Twoja zgoda będzie ważna przez 12 miesięcy, chyba że wcześniej ją
zmienisz. Jeśli nie wyrazisz zgody, Twój wybór będzie przechowywany
przez 14 dni.</p>
<p>W plikach cookies przechowuje się informacje, których Serwis może
potrzebować, aby:</p>
<ul>
  <li>dostosować się do sposobów korzystania z niego przez użytkowników,</li>
  <li>zbierać dane statystyczne dotyczące Serwisu, np. na temat tego, które strony
były odwiedzane, jakie elementy są pobierane, oraz dane o nazwie domeny
dostawcy usług internetowych czy kraju pochodzenia osoby odwiedzającej.</li>
</ul>

          <h4>Zasady ochrony danych osobowych</h4>
          <p><strong>Jak przetwarzamy dane osobowe w ramach Serwisu?</strong></p>
          <p>ORLEN S.A. z siedzibą w Płocku, ul. Chemików 7 informuje, że jest
administratorem danych osobowych użytkownika Serwisu. Kontaktowe
numery telefonów do ORLEN S.A.: (24) 256 00 00, (24) 365 00 00, (22)
778 00 00.</p>
          <p><strong>Inspektor ochrony danych</strong></p>
          <p>ORLEN S.A. wyznaczył inspektora ochrony danych, z którym można się
kontaktować we wszystkich sprawach dotyczących przetwarzania danych
osobowych oraz korzystania z praw związanych z przetwarzaniem
danych. Szczegółowe dane Inspektora ochrony danych w ORLEN S.A.
dostępne są na stronie www.orlen.pl w zakładce „Kontakty”. Jeżeli chcesz
skontaktować się z Inspektorem ochrony danych skorzystaj proszę z
następujących danych kontaktowych:</p>
        <ul>
          <li>adres: adres siedziby ORLEN S.A. z dopiskiem „Inspektor Ochrony
          Danych”</li>
          <li>adres email: daneosobowe@orlen.pl</li>
        </ul>

        <p><strong>W jakich celach są przetwarzane Twoje dane osobowe?</strong></p>
        <p>Twoje dane będą przetwarzane do celu realizacji usług ORLEN S.A.
Twoje dane mogą być także przetwarzane w celu dostosowania Serwisu
do sposobów korzystania, pomiarów statystycznych i udoskonalenia usług
ORLEN oraz w celu odpowiedzi na Twoje zapytanie a także wykrywania
nadużyć. Dodatkowo Twoje dane mogą być przetwarzane za Twoją zgodą
w celu wysyłania zamówionych informacji z Serwisu</p>

        <p><strong>Przez jaki okres będą przechowywane Twoje dane osobowe?</strong></p>
        <p>W odniesieniu do usług ORLEN S.A. Twoje dane będą przetwarzane
przez okres, w którym usługi te będą świadczone oraz, czasami, po
zakończeniu ich świadczenia, jednak wyłącznie jeżeli jest dozwolone lub
wymagane w świetle obowiązującego prawa np. przetwarzanie w celach
statystycznych, rozliczeniowych lub w celu dochodzenia roszczeń. W
takim przypadku dane będą przetwarzane przez okres niezbędny do
realizacji tego typu celów lub do momentu wyrażenia sprzeciwu lub do
czasu zakończenia korzystania przez Ciebie z usług Serwisu.
Jeżeli chodzi o dane osobowe przetwarzane za Twoją zgodą, np. w celu
wysyłania zamówionych informacji z Serwisu dane te będą przetwarzane
do casu wycofania zgody.</p>

      <p><strong>Jaka jest podstawa prawna przetwarzania Twoich danych osobowych?</strong></p>
      <p>W odniesieniu do usług ORLEN w ramach Serwisu Twoje dane będą
przetwarzane na podstawie art. 6 ust. 1 lit b) RODO (jest to niezbędne do
wykonania umowy, której stroną jest osoba, której dane dotyczą).</p>
      <p>Jeżeli chodzi o dopasowanie Serwisu do sposobów korzystania oraz
prowadzenie marketingu produktów lub usług własnych ORLEN oraz
pomiary statystyczne i udoskonalenie usług, udzielenia odpowiedzi na
zgłoszenia Twoje dane będą przetwarzane na podstawie art. 6 ust. 1 lit. f)
RODO (prawnie uzasadniony interes ORLEN). Prawnie uzasadnionym
interesem administratora jest dopasowanie treści Serwisu do Twoich
potrzeb, zapewnienie bezpieczeństwa tych usług, a także ich ciągłe
udoskonalanie.</p>
      <p>W odniesieniu do wysyłania zamówionych informacji z Serwisu na podane
w ramach Serwisu dane osobowe, to podstawą ich przetwarzania jest art.
6 ust. 1 lit. a) RODO (zgoda).</p>

      <p><strong>Wymóg podania danych</strong></p>
      <p>Podanie danych w celu realizacji usług ORLEN jest niezbędne do
świadczenia tych usług. W razie niepodania tych danych usługa nie będzie
mogła być świadczona.</p>
<p>Przetwarzanie danych w pozostałych celach tj. dopasowanie treści
Serwisu do Twoich zainteresowań, pomiarów statystycznych i
udoskonalenia usług w ramach Serwisu jest niezbędne w celu
zapewnienia wysokiej jakości usług. Niezebranie Twoich danych
osobowych w tych celach może uniemożliwić poprawne świadczenie
usług.</p>

<p><strong>Do jakich odbiorców przekazywane będą Twoje dane osobowe?</strong></p>
<p>Twoje dane mogą być przekazywane podmiotom przetwarzającym dane
osobowe na zlecenie administratora m.in. dostawcom usług IT, agencjom
marketingowym – przy czym takie podmioty przetwarzają dane na
podstawie umowy z administratorem i wyłącznie zgodnie z poleceniami
administratora.</p>

<p><strong>Jakie są Twoje prawa związane z przetwarzaniem danych osobowych?</strong></p>
<p>Przysługują Ci następujące prawa w związku z przetwarzaniem przez Nas
Twoich danych osobowych:</p>
<ul>
<li>prawo dostępu do Twoich danych,</li>
<li>prawo żądania sprostowania danych,</li>
<li>prawo do usunięcia danych (w określonych sytuacjach),</li>
<li>prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych,</li>
<li>prawo do ograniczenia przetwarzania danych.<br/>Jeżeli Twoje dane są przetwarzane na podstawie zgody lub w ramach
świadczonej usługi (dane są niezbędne w celu świadczenia usługi)
możesz dodatkowo skorzystać z poniższych praw:</li>
<li>prawo do wycofania zgody w zakresie w jakim są przetwarzane na tej
podstawie. Wycofanie zgody nie ma wpływu na zgodność z prawem
przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.</li>
<li>prawo do przenoszenia danych osobowych, tj. do otrzymania od
administratora Twoich danych osobowych, w ustrukturyzowanym,
powszechnie używanym formacie nadającym się do odczytu maszynowego.
Możesz przesłać te dane innemu administratorowi danych.</li>
</ul>

<p>W celu skorzystania z powyższych praw należy skontaktować się z
administratorem danych lub z inspektorem ochrony danych. Dane
kontaktowe wskazane są wyżej.</p>
<p>Jednocześnie informujemy, że przysługuje Tobie prawo do wniesienia
skargi do Prezesa Urzędu Ochrony Danych Osobowych.</p>

<h4>Postanowienia końcowe</h4>
<p>Usługi i funkcje w ramach Serwisu będą z czasem ulegać rozszerzeniu.
Oznacza to m.in., że w przyszłości ORLEN S.A. może wprowadzić zmiany
w niniejszym dokumencie. Ogłoszenie zmian nastąpi w ten sposób, że
informację o zmianach w Polityce Prywatności zostaną umieszczone w
ramach Serwisu. Wraz z każdą zmianą, nowa wersja Polityki Prywatności
będzie się pojawiać z nową datą. Wszelkie najistotniejsze zmiany będą
odpowiednio wyróżnione. Niniejszy dokument ma charakter informacyjny.</p>

          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalPolityka
